import { some } from "lodash";

import type { Carrier, EligibilityDetail } from "../promises/types/Quote";

export const isCarrierAvailable = (
  carrier: Carrier,
  blacklistedRuleIds: string[] = []
) => {
  if (!carrier.eligibility) {
    return false;
  }

  const isPrevent =
    blacklistedRuleIds.length > 0
      ? isRuleBlacklisted(carrier.eligibility.prevent, blacklistedRuleIds)
      : carrier.eligibility.prevent?.result;
  const isBlock =
    blacklistedRuleIds.length > 0
      ? isRuleBlacklisted(carrier.eligibility.block, blacklistedRuleIds)
      : carrier.eligibility.block?.result;

  return !isPrevent && !isBlock;
};

export const isRuleBlacklisted = (
  rules: EligibilityDetail,
  blacklistedRuleIds: string[]
) => {
  // see if any `result` in any `detail` that doesn't have a blacklisted `id` is true
  return some(rules.details, detail => {
    // if this ruleset id is blacklisted, overright any "true" result and return false
    if (blacklistedRuleIds.includes(detail.id)) {
      return false;
    }
    return detail.result;
  });
};
